import React from 'react';
import { Tabs } from 'tdesign-react';
import TabPanel from 'tdesign-react/es/tabs/TabPanel';
import Markdown from '@/pages/Dev/components/Markdown';
import { doBuried } from '@/services/buriedService';

export default function Code({ brokerServiceUrl }) {
  const content1 = `
  1.使用pip安装最新的版本客户端
  ~~~bash~DEV_PYTHON_PIP_1_COPY
    pip install 'pulsar-client==3.4.0'
  ~~~
  2.可选组件库安装
  ~~~bash~DEV_PYTHON_PIP_2_COPY
    # avro serialization
    pip install 'pulsar-client[avro]==3.4.0'
    # functions runtime
    pip install 'pulsar-client[functions]==3.4.0'
    # all optional components
    pip install 'pulsar-client[all]==3.4.0'
  ~~~
  `;
  const content2 = `
  ~~~python~DEV_PYTHON_PRODUCER_COPY
  import pulsar

  client = pulsar.Client('${brokerServiceUrl}')

  producer = client.create_producer('persistent://public/default/test')

  # 发送10条消息
  for i in range(10):
    producer.send(('Hello World-%d' % i).encode('utf-8'))

  client.close()
  ~~~
  `;
  const content3 = `
  ~~~python~DEV_PYTHON_CONSUMER_COPY
  import pulsar

client = pulsar.Client('${brokerServiceUrl}')

consumer = client.subscribe('persistent://public/default/test', 'test_sub')

while True:
    msg = consumer.receive()
    try:
        print("Received message '{}' id='{}'".format(msg.data(), msg.message_id()))
        consumer.acknowledge(msg)
    except Exception:
        # 消息处理失败，稍后重新发送
        consumer.negative_acknowledge(msg)

client.close()
  ~~~
  `;

  return (
    <Tabs defaultValue='DEV_PYTHON_PIP' onChange={(val) => doBuried({ eventId: val })}>
      <TabPanel value='DEV_PYTHON_PIP' label='Pip'>
        <Markdown content={content1} />
      </TabPanel>
      <TabPanel value='DEV_PYTHON_PRODUCER' label='Producer'>
        <Markdown content={content2} />
      </TabPanel>
      <TabPanel value='DEV_PYTHON_CONSUMER' label='Consumer'>
        <Markdown content={content3} />
      </TabPanel>
    </Tabs>
  );
}
